/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SiteResponseModel } from '../../models/site-response-model';

export interface GetMerchantSite$Params {
  merchantId: string;
  siteId: string;
}

export function getMerchantSite(http: HttpClient, rootUrl: string, params: GetMerchantSite$Params, context?: HttpContext): Observable<StrictHttpResponse<SiteResponseModel>> {
  const rb = new RequestBuilder(rootUrl, getMerchantSite.PATH, 'get');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
    rb.path('siteId', params.siteId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SiteResponseModel>;
    })
  );
}

getMerchantSite.PATH = '/merchants/{merchantId}/sites/{siteId}';
